import React from 'react';

import * as styles from './profile-tab-separator.module.styl';

export const ProfileTabSeparator = () => (
    <div className={styles.profileTabSeparator}/>
);
